module.exports = __webpack_public_path__ + "img/product-1.7812728b.jpeg";